import { render, staticRenderFns } from "./InformasiLainnyaDetail-Desktop.vue?vue&type=template&id=5bc127c2&scoped=true&"
import script from "./InformasiLainnyaDetail-Desktop.vue?vue&type=script&lang=js&"
export * from "./InformasiLainnyaDetail-Desktop.vue?vue&type=script&lang=js&"
import style0 from "./InformasiLainnyaDetail-Desktop.vue?vue&type=style&index=0&id=5bc127c2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bc127c2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VImg,VRow})
